import {
  getUpcomingTimeDisplay,
  isInAfterWindow,
  isInCountdownWindow,
  isInPreviewWindow,
  isLiveNow,
} from 'components/common/ToastNotifications/utils/time';
import { useState } from 'react';
import { useInterval } from 'react-use';
import type { LiveNotification } from 'types/cms/ToastNotification';

import { Countdown } from './Countdown';
import { LiveNow } from './LiveNow';
import { TimeText } from './TimeText';

const INTERVAL = 1000;

function LiveStatusResolver({ banner }: { banner: LiveNotification }) {
  const { displayTimes: times } = banner;
  const [currentTime, setCurrentTime] = useState(new Date());

  useInterval(
    () => {
      if (!banner) return;
      setCurrentTime(new Date());
    },
    isInAfterWindow(times) ? null : INTERVAL,
  );

  if (isLiveNow(times)) {
    return <LiveNow {...banner} />;
  }

  /* Display After */
  if (isInAfterWindow(times)) {
    return <TimeText>Previously live</TimeText>;
  }

  /* Display Before */
  if (isInPreviewWindow(times)) {
    if (isInCountdownWindow(times)) {
      return <Countdown times={times} currentTime={currentTime} />;
    }
    const upcomingTime = getUpcomingTimeDisplay(times);
    if (upcomingTime) {
      return <TimeText whiteSpace="pre">{upcomingTime}</TimeText>;
    }
  }

  return null;
}

export default LiveStatusResolver;
